<template>
  <div>
    <Header></Header>
    <Expired :title="title" :text="text" login="true"></Expired>
  </div>
</template>

<script>

  import '@/assets/styles/auth/main.scss'
  import { mapGetters, mapMutations, mapActions } from "vuex"

  import Header from '@/components/auth/Header'
  import Expired from '@/components/auth/Expired'

  export default {
    data() {
      return {
        title: this.$t('auth.verification.verified'),
        text: this.$t('auth.verification.loading')
      }
    },
    components: {
      Header, Expired
    },
    computed: {
      ...mapMutations([
        "setMessage"
      ])
    },
    methods: {
      ...mapActions([
        "fetch_request"
      ])
    },
    async mounted() {
      document.head.querySelector("[name~=theme-color][content]").content = '#fff'
			document.head.querySelector("[name~=viewport][content]").content = 'width=device-width,initial-scale=1.0'
			document.querySelector('body').classList.add('responsive')
      document.querySelector('body').classList.add('intropage')
      if (this.$route.params.code) {

        const result = await this.fetch_request({
          token: false,
          method: "POST",
          url: this.$w_api.POST_Verification,
          body: {
            code: this.$route.params.code
          }
        })

        const data = await result.json()
        this.title = data.title
        this.text = data.text

      }
    },
    unmounted() {
      document.querySelector('body').classList.remove('intropage')
    }
  }

</script>